import { useState, type FormEvent } from "react";
import type { ApiClient } from "../lib/api";

interface Props {
  api: ApiClient;
  onAuthenticated: (token: string) => void;
  onOpenLocal: (file: File) => void;
}

export function AuthScreen({ api, onAuthenticated, onOpenLocal }: Props) {
  const [mode, setMode] = useState<"login" | "register">("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      const result = await api.authenticate(mode, email, password);
      onAuthenticated(result.token);
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : "認証に失敗しました");
    } finally {
      setBusy(false);
    }
  }

  return <main className="auth-shell">
    <section className="auth-story">
      <div className="brand"><span className="brand-mark">FT</span><span>FACTORY TWIN</span></div>
      <div className="eyebrow">SPATIAL OPERATIONS PLATFORM / 01</div>
      <h1>現場の知識を、<br /><em>空間に残す。</em></h1>
      <p className="lede">動画から構築した3Dデジタルツインに、安全情報と作業手順を直接配置。工場の「見る・伝える・守る」を、ひとつの画面へ。</p>
      <div className="feature-strip">
        <div><strong>3DGS</strong><span>写真品質の空間再現</span></div>
        <div><strong>R2 / D1</strong><span>安全なクラウド運用</span></div>
        <div><strong>3D PIN</strong><span>座標に残る現場知</span></div>
      </div>
      <div className="factory-grid" aria-hidden="true"><span /><span /><span /><span /><span /></div>
    </section>
    <section className="auth-panel">
      <div className="system-status"><i /> SYSTEM READY <span>JP-01</span></div>
      <div className="auth-card">
        <div className="auth-tabs">
          <button className={mode === "login" ? "active" : ""} onClick={() => setMode("login")}>ログイン</button>
          <button className={mode === "register" ? "active" : ""} onClick={() => setMode("register")}>新規登録</button>
        </div>
        <h2>{mode === "login" ? "ワークスペースへ" : "アカウントを作成"}</h2>
        <p>{mode === "login" ? "登録済みの認証情報を入力してください。" : "10文字以上のパスワードを設定してください。"}</p>
        <form onSubmit={submit}>
          <label>メールアドレス<input type="email" value={email} onChange={(event) => setEmail(event.target.value)} placeholder="operator@factory.jp" required /></label>
          <label>パスワード<input type="password" value={password} onChange={(event) => setPassword(event.target.value)} placeholder="10文字以上" minLength={10} required /></label>
          {error && <div className="form-error" role="alert">{error}</div>}
          <button className="primary-button" disabled={busy}>{busy ? "接続中…" : mode === "login" ? "ログイン →" : "アカウント作成 →"}</button>
        </form>
        <div className="divider"><span>または</span></div>
        <label className="local-open">ローカル3DGSを試す<input type="file" accept=".ply,.splat,.ksplat,.spz" onChange={(event) => { const file = event.target.files?.[0]; if (file) onOpenLocal(file); }} /></label>
        <small>モデルはブラウザ内だけで開かれ、アップロードされません。</small>
      </div>
      <footer>SECURE SESSION · TLS 1.3 <span>v0.1.0</span></footer>
    </section>
  </main>;
}

